// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SjgQ","footer":"styles_footer__1h-9y"};